"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "icon": _icons.AnalyticsIcon,
  "layout": "finder",
  "name": "analytics",
  "title": "Statistikk",
  "theme": {
    "primaryColor": "#3154ea",
    "lightColor": "#8aa7f7",
    "darkColor": "#24439f"
  },
  "search": {
    "placeholder": "Søk i statistikk"
  },
  "button": {
    "title": "New report"
  },
  "filters": [{
    "title": "Today",
    "value": "today"
  }, {
    "title": "Yesterday",
    "value": "yesteday"
  }, {
    "title": "Last 7 days",
    "value": "7days"
  }, {
    "title": "Last 28 days",
    "value": "28days"
  }, {
    "title": "Last 90 days",
    "value": "90days"
  }],
  "menu": [{
    "title": "Analytics",
    "path": ""
  }, {
    "title": "Reports",
    "name": "reports",
    "count": 7,
    "children": [{
      "title": "Pages",
      "name": "pages",
      "count": 4
    }, {
      "title": "Users",
      "name": "users",
      "count": 3
    }]
  }]
};
exports.default = _default;
module.exports = exports.default;